import PreviewCard, { PreviewLocationRow, PreviewMedia } from './PreviewCard';

export default function AddressPreview({ address }: { address: string }) {
  return (
    <PreviewCard>
      <PreviewMedia className="flex items-center justify-center lg:h-[13.5rem]">
        <img
          src="/images/app/pin-gradient.svg"
          alt=""
          className="h-24 w-24 lg:h-[7.5rem] lg:w-[7.5rem]"
        />
      </PreviewMedia>
      <PreviewLocationRow address={address} />
    </PreviewCard>
  );
}
